import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import i18next from "i18next";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";

import App from "./App";
import AppErrorBoundary from "./components/AppErrorBoundary";
import { formatBuildTime } from "./utils/appVersion";

import "./icons/icomoon/style.css";

console.info("React version:", React.version);
console.info("Current branch:", process.env.REACT_APP_GIT_BRANCH);
console.info("Build time:", formatBuildTime());

i18next
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: false,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    backend: {
      crossDomain: true,
      loadPath: `${window.location.origin}/locales/{{lng}}/translation.json`,
    },
  });

const root = createRoot(document.getElementById("root") as HTMLElement);
// Outside Suspense as well as outside App: a provider that throws while the i18n bundle is still
// in flight has to land somewhere too.
root.render(
  <AppErrorBoundary>
    <Suspense fallback={null}>
      <App />
    </Suspense>
  </AppErrorBoundary>
);
